export enum CarouselType {
  FEATURED_PAID = 'Featured Classifeds - paid (À la une)',
  MORE_FROM_USER = 'More from user',
  SIMILAR_CLASSIFIEDS = 'Similar classifieds',
  SHOWCASED_CATEGORY = 'Showcased category',
  USER_VISITED_HISTORY = 'Visited Classifieds History',
  SHOP_OF_MONTH = 'Shop of month',
  IQOS_SHOP = 'Iqos shop',
}
